import Navigation from "../components/gala/Navigation";
import Hero from "../components/gala/Hero";
import ImpactDashboard from "../components/gala/ImpactDashboard";
import { WhyMatters, EventExperience, PastSuccess } from "../components/gala/EventSections";
import HallOfFame from "../components/gala/HallOfFame";
import Scholarship from "../components/gala/Scholarship";
import Sponsorship from "../components/gala/Sponsorship";
import StrategicPartnership from "../components/gala/StrategicPartnership";
import MediaCenter from "../components/gala/MediaCenter";
import { VIPTable, Hotels } from "../components/gala/VipHotels";
import { VendorForm, VolunteerForm } from "../components/gala/VendorVolunteer";
import VendorMarketplace from "../components/gala/VendorMarketplace";
import { ContactInvoice } from "../components/gala/Contact";
import Footer from "../components/gala/Footer";
import { SponsorsCarousel, PartnerSpotlights, AnnouncementsFeed } from "../components/gala/DynamicSections";
import RecognitionWall from "../components/gala/RecognitionWall";
import DonorRecognitionWall from "../components/gala/DonorRecognitionWall";

export default function GalaSite() {
  return (
    <div className="bg-aawta-jet text-white min-h-screen">
      <Navigation />
      <main>
        <Hero />
        <ImpactDashboard />
        <RecognitionWall />
        <WhyMatters />
        <SponsorsCarousel />
        <EventExperience />
        <PastSuccess />
        <AnnouncementsFeed />
        <DonorRecognitionWall />
        <HallOfFame />
        <Sponsorship />
        <PartnerSpotlights />
        <Scholarship />
        <StrategicPartnership />
        <VIPTable />
        <Hotels />
        <MediaCenter />
        <VendorMarketplace />
        <VendorForm />
        <VolunteerForm />
        <ContactInvoice />
      </main>
      <Footer />
    </div>
  );
}
